// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"1c7c6079","81":"295efb88","325":"3ad95c67","495":"3f3b1fc9","682":"40cdd010","941":"a8dc26b5","967":"13dee1ed"}[chunkId] + ".chunk.js";
};